<template>
  <div>
    <button type="button" @click="addNewRecord" class="btn btn-xs btn-default mb-1">Добавить запись</button>
    <table class="table table-sm m-0">
      <tbody>
      <tr v-for="(rds, countryId) in records"
          v-if="['supplier_data', 'country_data'].includes(rds.group_alias) && rds.alias === 'title'">
        <td>
          <select v-model="rds.group_alias" @change="updateType(rds)" :disabled="rds.to_delete" class="form-control">
            <option value="supplier_data">поставщик</option>
            <option value="country_data">страна</option>
          </select>
        </td>
        <td>
          <select v-model="rds.int_value" class="form-control"
                  :disabled="rds.to_delete">
            <template v-if="rds.group_alias === 'country_data'">
              <option :value="0">любая страна</option>
              <option v-for="c in $AllCountries" :value="c.id">{{ c.name }}</option>
            </template>
            <template v-else>
              <option :value="0">любой поставщик</option>
              <option v-for="c in suppliers" :value="c.id">{{ c.title }}</option>
            </template>
          </select>
        </td>
        <td>
          <input type="text" placeholder="Наименование" :disabled="rds.to_delete" v-model="rds.text_value"
                 class="form-control">
        </td>
        <!--        <td class='d_data'>-->
        <!--          <input type="number" placeholder="Ширина (мм)" :disabled="rds.to_delete"-->
        <!--                 v-model="rds.dimensions.array_value.width"-->
        <!--                 class="form-control">-->
        <!--        </td>-->
        <!--        <td class='d_data'>-->
        <!--          <input type="number" placeholder="Высота (мм)" :disabled="rds.to_delete"-->
        <!--                 v-model="rds.dimensions.array_value.height" class="form-control">-->
        <!--        </td>-->
        <!--        <td class='d_data'>-->
        <!--          <input type="number" placeholder="Глубина (мм)" :disabled="rds.to_delete"-->
        <!--                 v-model="rds.dimensions.array_value.depth" class="form-control">-->
        <!--        </td>-->
        <!--        <td class='d_data'>-->
        <!--          <input type="number" placeholder="Вес (гр)" :disabled="rds.to_delete"-->
        <!--                 v-model="rds.dimensions.array_value.weight" class="form-control">-->
        <!--        </td>-->
        <td>
          <button @click="rds.to_delete = !rds.to_delete" class="btn btn-default" type="button">
            <i class="icon-fa icon-fa-remove"/></button>
        </td>
      </tr>
      </tbody>
    </table>
  </div>
</template>

<script>

import api from "@/api";

export default {
  props: ['records'],
  data() {
    return {
      allRecords: [],
      suppliers: [],
    }
  },
  created() {
    // Object.keys(this.records ?? {}).forEach((g) => {
    //   if (!this.records[g].dimensions) this.records[g].dimensions = {
    //     int_value: g,
    //     type: 'array',
    //     array_value: {width: null}
    //   };
    //   console.log(this.records[g].dimensions);
    //   if (!this.records[g].dimensions.array_value) this.$set(this.records[g].dimensions, 'array_value', {width: null});
    //   console.log(this.records[g].dimensions);
    //   if (!this.records[g].title) {
    //     this.records[g].title = {
    //       int_value: g,
    //       type: 'text'
    //     }
    //   }
    // })
    this.getSuppliers();
  },
  computed: {
    $AllCountries() {
      return this.$store.getters['platform/countries'];
    },
  },
  methods: {
    updateType(record) {
      record.int_value = 0;
    },
    async getSuppliers() {
      this.loading = true;
      let {data} = await api.index('/new/suppliers?noPages=1');
      if (data.success) {
        this.suppliers = _.orderBy(data.records, 'title');
      }
      this.loading = false;
    },
    updateCountry() {
      Object.keys(this.records).forEach((g) => {
        this.records[g].dimensions.int_value = this.records[g].country_id;
        this.records[g].title.int_value = this.records[g].country_id;
      });
    },
    addNewRecord() {
      let index = Math.min.apply(null, Object.keys(this.records ?? {}).map((k) => +k)) - 1;
      if (!index || index > 0) index = -1;
      console.log(index);
      this.records.push({
        country_id: 0,
        to_delete: false,
        dimensions: {int_value: 0, type: 'array', array_value: {width: null}},
        title: {int_value: 0, type: 'text'}
      });
    }
  }
}

</script>

<style scoped>
table td {
  padding: 5px;
}

.d_data {
  width: 145px;
}
</style>
